import type { PrimaryWebsite } from "../types";

export enum PromptSource {
    Input = "input",
    Chip = "chip",
}

export type PromptSchema = { source: PromptSource; prompt: string };

export type CompetitorSchema = {
    name: string;
    image: string;
    reason?: string;
    isAiGenerated?: boolean;
};

export type CompetitorsMap = Map<string, CompetitorSchema>;

export type CompetitorsStepSchema = {
    selectedPrimaryEntity?: PrimaryWebsite;
    setPrimary(primary: PrimaryWebsite): void;
    onCompetitorSelect: (competitor: CompetitorSchema) => void;
    setSelectedCompetitors: (competitors: CompetitorSchema[]) => void;
    onCountrySelect: (countryCode: number) => void;
    selectedCompetitors: CompetitorSchema[];
    showWebsiteSelect: boolean;
    savedThreadId?: string;
    setSavedThreadId: (id: string) => void;
    handleFocus: () => void;
    handleBlur: () => void;
    selectedCountry: number;
    isOpen: boolean;
};
